export default "__VITE_ASSET__Dr3P7bX6__"